export enum JobEventType {
  PROCESS = 'PROCESS',
  PURGE = 'PURGE',
}
